import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid" }
const _hoisted_2 = { class: "col-12 md:col-2 field p-fluid" }
const _hoisted_3 = { class: "col-12 md:col-2 field p-fluid" }
const _hoisted_4 = { class: "col-12 md:col-2 field flex flex-column justify-content-end" }
const _hoisted_5 = {
  class: "col-12",
  style: {"height":"50vh"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_l_tile_layer = _resolveComponent("l-tile-layer")!
  const _component_l_map = _resolveComponent("l-map")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "m-3" }, {
    title: _withCtx(() => _cache[2] || (_cache[2] = [
      _createTextVNode("Map Report")
    ])),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[3] || (_cache[3] = _createElementVNode("label", { for: "calendar" }, "วันที่รายงาน", -1)),
          _createVNode(_component_Calendar, {
            id: "calendar",
            modelValue: _ctx.screen.selectedDate,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.screen.selectedDate) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[4] || (_cache[4] = _createElementVNode("label", { for: "shipmentNo" }, "ระบุ Shipment", -1)),
          _createVNode(_component_Dropdown, {
            id: "shipmentNo",
            modelValue: _ctx.screen.shipmentNo,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.screen.shipmentNo) = $event)),
            options: _ctx.shipments,
            optionValue: "code",
            optionLabel: "description"
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Button, { icon: "pi pi-search" })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_l_map, {
            center: [8, 103],
            zoom: 10
          }, {
            default: _withCtx(() => [
              _createVNode(_component_l_tile_layer, { url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}